// @ts-check
import _ from 'lodash';

/**
 * @constant {string[]}
 */
export const defaultColors = [
  '#4363d8', '#e6194b', '#3cb44b', '#ffe119', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#000000'
];
/**
 * @typedef {Object} GetColorsProps
 * @property {string[]} [usedColors=[]]
 * @property {number} [numColors=1]
 */

/**
 *
 * @param {GetColorsProps} props
 * @returns {string[]}
 */
export const getColors = ({ usedColors = [], numColors = 1 }) => {
  if (_.size(usedColors) >= _.size(defaultColors) * 2) {
    return _.sampleSize(defaultColors, numColors);
  }
  const duplicates = _.filter(usedColors, (color, index, iteratee) => _.includes(iteratee, color, index + 1));
  var availableColors = _.difference(defaultColors, usedColors);
  if (!_.isEmpty(duplicates)) {
    availableColors = _.difference(defaultColors, duplicates);
  }
  return availableColors.slice(0, numColors);
};
